
































































import { computed, defineComponent } from '@vue/composition-api';
import { useStakingStore } from '../../stores/Staking';
import { useAddressStore } from '../../stores/Address';
import { useRouter } from '../../router';
import Amount from '../Amount.vue';
import FiatConvertedAmount from '../FiatConvertedAmount.vue';
import RoundStakingIcon from '../icons/Staking/RoundStakingIcon.vue';
import ValidatorIcon from './ValidatorIcon.vue';
import ValidatorTrustScore from './tooltips/ValidatorTrustScore.vue';
import ValidatorReward from './tooltips/ValidatorReward.vue';
import ShortAddress from '../ShortAddress.vue';
import { useNetworkStore } from '../../stores/Network';
import CircleArrowDownIcon from '../icons/Staking/CircleArrowDownIcon.vue';
import CircleExclamationMarkIcon from '../icons/Staking/CircleExclamationMarkIcon.vue';

export default defineComponent({
    setup() {
        const { activeAddressInfo } = useAddressStore();
        const { activeStake: stake, activeValidator: validator, restakingRewards } = useStakingStore();
        const router = useRouter();
        const { height } = useNetworkStore();

        const availableBalance = computed(() => activeAddressInfo.value?.balance || 0);
        const stakedBalance = computed(() => stake.value
            ? stake.value.activeBalance + stake.value.inactiveBalance + stake.value.retiredBalance
            : 0);

        const percentage = computed(() => Math.round((
            stakedBalance.value / (availableBalance.value + stakedBalance.value)
        ) * 100));

        const inactiveReleaseTime = computed(() => {
            if (stake.value?.inactiveRelease) {
                // TODO: Take validator jail release into account
                const secondsRemaining = stake.value.inactiveRelease - height.value;
                const date = new Date(Date.UTC(0, 0, 0, 0, 0, secondsRemaining));
                const hours = date.getUTCHours().toString().padStart(2, '0');
                const minutes = date.getUTCMinutes().toString().padStart(2, '0');
                const seconds = date.getUTCSeconds().toString().padStart(2, '0');
                return [
                    ...(hours !== '' ? [hours] : []),
                    minutes,
                    seconds,
                ].join(':');
            }

            return '00:00';
        });

        const hasUnstakableStake = computed(() => {
            if (!stake.value?.inactiveBalance) return false;
            return height.value > stake.value.inactiveRelease!;
        });

        const openStakingModal = () => {
            router.push({ name: 'staking' });
        };

        const openValidatorDetailsModal = () => {
            router.push({ name: 'validator-details' });
        };

        return {
            stake,
            validator,
            restakingRewards,
            stakedBalance,
            percentage,
            inactiveReleaseTime,
            hasUnstakableStake,
            openStakingModal,
            openValidatorDetailsModal,
        };
    },
    components: {
        Amount,
        FiatConvertedAmount,
        RoundStakingIcon,
        ValidatorIcon,
        ValidatorTrustScore,
        ValidatorReward,
        ShortAddress,
        CircleArrowDownIcon,
        CircleExclamationMarkIcon,
    },
});
